module.exports = __webpack_public_path__ + "res/28-img_more.8fba213dcc4875162297dbb606b09f8a.png";